import $http_ari from '../../../axios-instance-ari';
import Swal from 'sweetalert2';
import $http from '../../../axios-instance';
import { validarPermisoComponente } from '../../../plugins/acl';

/**
 * Obtener las propiedades de un producto
 */
export async function obtenerPropiedades({commit, rootState}, idProd) {
    if (validarPermisoComponente('visualizar-propiedades-producto')) {
        let id_producto = rootState.productos.selectedProduct.id;

        if (!id_producto) {
            id_producto = idProd;
        }

        if (id_producto) {
            commit('dashboard/load', true, {root: true});
            await $http_ari.get('propiedades-productos/' + id_producto)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    commit('establecerPropiedades', response.data.propiedades);
                })
                .catch((error) => {
                    commit('dashboard/load', false, {root: true});
                });
        } else {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error, no existe el producto',
                showConfirmButton: true,
                timer: 3000
            });
        }
    }
}

/**
 * Enviar propiedades de un producto.
 */
export async function guardarPropiedades({commit, state, rootState, dispatch}, idProd = null) {
    if (validarPermisoComponente('crear-propiedades-producto')) {
        let id_producto = rootState.productos.selectedProduct.id;

        if (!id_producto) {
            id_producto = idProd;
        }

        if (id_producto) {

            commit('establecerIdProductoEnPropiedades', id_producto);
            commit('dashboard/load', true, {root: true});
            await $http_ari.post('propiedades-productos', state.propiedades).then(async (response) => {
                await dispatch('obtenerAnimales')
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: true,
                    timer: 3000
                });
            }).catch((error) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.error,
                    showConfirmButton: true,
                    timer: 3000
                });
            });
        } else {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error, no existe el producto',
                showConfirmButton: true,
                timer: 3000
            });
        }
    }
}

/**
 * Obtener Listas por el código del control
 */
export async function obtenerListasPorCodigoControl({commit}, codigo) {
    return new Promise(async (resolve) => {
        if (codigo) {
            commit('dashboard/load', true, {root: true});
            await $http.get(`/adm_general/listas/codigo-control/${codigo}`)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    resolve(response.data.data);
                }).catch(() => {
                    commit('dashboard/load', false, {root: true});
                    resolve([]);
                });
        } else {
            resolve([]);
        }
    });
}

/**
 * Obtener presentaciones
 */
export async function obtenerPresentaciones({state, commit, dispatch}) {
    if (!state.presentaciones.length) {
        await dispatch('obtenerListasPorCodigoControl', 'PRESEN')
            .then((data) => commit('establecerPresentaciones', data))
            .catch(() => console.log('Error al obtener las listas'));
    }
}

/**
 * Obtener unidades de temperatura
 */
export async function obtenerUnidadesDeTemperatura({state, commit, dispatch}) {
    if (!state.unidades_de_temperatura.length) {
        await dispatch('obtenerListasPorCodigoControl', 'UTEMP')
            .then((data) => commit('establecerUnidadesDeTemperatura', data))
            .catch(() => console.log('Error al obtener las listas'));
    }
}

/**
 * Obtener unidades de presión
 */
export async function obtenerUnidadesDePresion({state, commit, dispatch}) {
    if (!state.unidades_de_presion.length) {
        await dispatch('obtenerListasPorCodigoControl', 'UPRES')
            .then((data) => commit('establecerUnidadesDePresion', data))
            .catch(() => console.log('Error al obtener las listas'));
    }
}

/**
 * Obtener unidades de viscosidad
 */
export async function obtenerUnidadesDeViscosidad({state, commit, dispatch}) {
    if (!state.unidades_de_viscosidad.length) {
        await dispatch('obtenerListasPorCodigoControl', 'UVISC')
            .then((data) => commit('establecerUnidadesDeViscosidad', data))
            .catch(() => console.log('Error al obtener las listas'));
    }
}

/**
 * Obtener opciones DL50
 */
export async function obtenerOpcionesDl50({state, commit, dispatch}) {
    if (!state.opciones_dl50.length) {
        await dispatch('obtenerListasPorCodigoControl', 'DL50')
            .then((data) => commit('establecerOpcionesDl50', data))
            .catch(() => console.log('Error al obtener las listas'));
    }
}

/**
 * Obtener opciones CL50
 */
export async function obtenerOpcionesCl50({state, commit, dispatch}) {
    if (!state.opciones_cl50.length) {
        await dispatch('obtenerListasPorCodigoControl', 'CL50')
            .then((data) => commit('establecerOpcionesCl50', data))
            .catch(() => console.log('Error al obtener las listas'));
    }
}

/**
 * Obtener opciones CL50
 */
export async function obtenerUnidadesDensidad({state, commit, dispatch}) {
    if (!state.unidadesDensidad.length) {
        await dispatch('obtenerListasPorCodigoControl', 'UNIDEN')
            .then((data) => commit('establecerUnidadesDensidad', data))
            .catch(() => console.log('Error al obtener las listas'));
    }
}

/**
 * Obtener opciones Capacidades
 */
export async function obtenerCapacidades({state, commit, dispatch}) {
    if (!state.capacidades.length) {
        await dispatch('obtenerListasPorCodigoControl', 'CAPA')
            .then((data) => commit('establecerCapacidades', data))
            .catch(() => console.log('Error al obtener las listas'));
    }
}

/**
 * Obtener animales
 */
export async function obtenerAnimales({state, commit, dispatch}) {
    await dispatch('obtenerListasPorCodigoControl', 'ANIM')
        .then((data) => commit('establecerAnimales', data))
        .catch(() => console.log('Error al obtener las listas'));
}

/**
 * Validar eliminación DlCl
 */
export async function validarEliminacionDlCl({commit, state, rootState, dispatch}, indice) {
    await Swal.fire({
        title: 'Eliminar',
        text: '¿Está seguro de eliminar el indicador biológico?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar',
        cancelButtonText: 'Cancelar'
    }).then(async (result) => {
        if (result.value) {
            commit('eliminarDlCl', indice);
        }
    });
}

/**
 * Guardar o actualizar el pH de un producto
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param id_producto - Identificador del producto.
 * @param ph - Valor del pH del producto.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function savePhProperties({ commit }, { id_producto, ph }) {
    try {
        commit('dashboard/load', true, { root: true });
        await $http.post(`product-property/create-or-update/ph`, { id_producto, ph });
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
        return false;
    } finally {
        commit('dashboard/load', false, { root: true });
    }
}
